export default __webpack_public_path__ + "static/media/multi-chain.f6daaa6d.svg";